import { CONFIG } from 'src/app/_config/config';
import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

interface HelpModel {
docs: any [] ;
url: string;
}


@Injectable({
  providedIn: 'root'
})
export class HelpService {

  help = new BehaviorSubject<any>({});
 gateway = this.config.gateway;

  private url = `${this.gateway.url}/help`;
  constructor(
    private http: HttpClient,
    public router: Router,
    private config: CONFIG
    ) {
      // this.getHelp();
     }

     getHelp() {
       try{
        //console.log('getHelp');
        this.http.get(this.url)
        .subscribe(
          (record: HelpModel) => {
            //console.log(this.router.url);
            //console.log(record);
            record.docs.forEach(element => {
              if (element.name === this.router.url) {
                this.help.next(record.url + element.href);
                console.log('element.name', this.help);
              }
            });
          }
        )
       }catch(error){
        console.log('Error help');
       }
      
     }


}
